import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
function PageHeader(props: any) {
  const navigate = useNavigate();
  return (
    <div className="AdminHeader-pageHeader">
      <div className="AdminHeader-pageHeader-Box" onClick={() => navigate(-1)}>
        <BsArrowLeft size={30} />
      </div>
      <div>
        <div className="AdminHeader-txt1">{props?.title}</div>
        <div className="AdminHeader-txt2">
          Admin {">"} <span style={{ color: "#0026ab" }}>{props?.title}</span>
        </div>
      </div>
      <div style={{ flex: 1 }} />
      {props?.children ? <div>{props?.children}</div> : null}
    </div>
  );
}

export default PageHeader;
